var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-container"},[_c('iframe',{staticStyle:{"min-height":"calc(100vh - 60px)"},attrs:{"src":"https://ggapi.hippofunnygame.com/iframe/index.html?type=1#/adsense-email-data","frameborder":"0","width":"100%","height":"100%"}})])
}]

export { render, staticRenderFns }